// extracted by css-extract-rspack-plugin
export default {"BlockedSectionMessage":"BlockedSection-module__BlockedSectionMessage__z5O597l","CircleOcticon":"BlockedSection-module__CircleOcticon__oUmHbNh"};